/** `/c/$companyId/settings/users` — Users and roles, for the account owner only. */
import type { JSX } from "react";
import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "@linkhr/i18n";
import { useMePermissions } from "../api/useMePermissions";
import { ownsCompany } from "../shell/gate";
import { UsersScreen } from "../users/UsersScreen";
import { companyTimeZone } from "../users/access";

export const Route = createFileRoute("/_auth/c/$companyId/settings/users")({
  component: UsersRoute,
});

function UsersRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const { i18n } = useTranslation("accounting");
  // The company layout has already read the permissions and let this company in.
  const company = useMePermissions().data?.companies.find((c) => c.id === companyId);
  if (company === undefined || !ownsCompany(company)) {
    return <Navigate to="/c/$companyId" params={{ companyId }} replace />;
  }
  const name = i18n.language.startsWith("ar") ? company.nameAr : (company.nameEn ?? company.nameAr);
  return (
    <UsersScreen
      companyId={companyId}
      companyName={name}
      timeZone={companyTimeZone(company?.country)}
    />
  );
}
